/**
 * 将 RTK Query 或原生 Fetch 错误转换为 BOM 页面统一错误信息。
 * @param {Object|Error|null} error 请求错误
 * @param {string} fallbackMessage 默认错误文案
 * @returns {{isRateLimited: boolean, message: string}} 标准错误信息
 */
export const getBomRequestErrorDetails = (error, fallbackMessage) => ({
  isRateLimited: Number(error?.status) === 429,
  message: error?.data?.message || error?.message || fallbackMessage,
});

/**
 * 判断 BOM 写请求是否因其他页面先保存而发生版本冲突。
 * @param {Object|Error|null} error 请求错误
 * @returns {boolean} 是否为可提示覆盖的版本冲突
 */
export const isBomWriteConflict = (error) => Number(error?.status) === 409;

/**
 * 根据失败的 Fetch 响应创建保留 HTTP 状态的 BOM 请求错误。
 * @param {Response} response Fetch 响应
 * @param {string} fallbackMessage 默认错误文案
 * @returns {Promise<{status: number, data: Object, message: string}>} 标准请求错误
 */
export const createBomResponseError = async (response, fallbackMessage) => {
  const data = await response.json().catch(() => ({}));
  return {
    status: response.status,
    data,
    message: data?.message || fallbackMessage,
  };
};
